import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Welcome from "./components/auth/Welcome";
import Login from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import Verification from "./components/auth/Verification";
import ForgotPassword from "./components/auth/ForgotPassword";

//Market Tab Routes
import Market from "./components/Market/Market";
import SearchBar from "./components/SearchBar";

//WatchList Tab Routes
// import WatchList from "./components/WatchList";

import WatchList from "./components/WatchList/WatchList";
//Account Tab Routes
import Account from "./components/Account";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Profile from "./components/Profile";
import TransactionHistory from "./components/TransactionHistory";
import AccountDeposit from "./components/AccountDeposit";
import AccountWithdraw from "./components/AccountWithdraw";
import AccountChangePassword from "./components/AccountChangePassword";
import RejectionLogs from "./components/RejectionLogs";
import LedgerMaster from "./components/LedgerMaster";
import BillHistory from "./components/BillHistory";
import AddOrder from "./components/AddOrder/AddOrder";
import Portfolio from "./components/Portfolio/Portfolio";
// import Order from "./components/Order";
import Order from "./components/orders/Order";
import EditOrder from "./components/orders/EditOrder";
import Plans from "./components/plans";
import { NotificationProvider } from "./components/NotificationContext";
import BalanceNotification from "./components/BalanceNotification";

function App() {
  return (
    <AuthProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />

          <Route
            path="/*"
            element={
              <NotificationProvider>
                <Routes>
                  <Route path="/forgot-password" element={<ForgotPassword />} ></Route>
                  <Route path="/market" element={<PrivateRoute><Market /></PrivateRoute>}></Route>
                  <Route path="/search-bar" element={<PrivateRoute><SearchBar /></PrivateRoute>}></Route>
                  <Route path="/add-order" element={<PrivateRoute><AddOrder /></PrivateRoute>}></Route>
                  <Route path="/edit-order" element={<PrivateRoute><EditOrder /></PrivateRoute>}></Route>

                  <Route path="/watchlist" element={<PrivateRoute><WatchList /></PrivateRoute>}></Route>
                  <Route path="/portfolio" element={<PrivateRoute><Portfolio /></PrivateRoute>}></Route>
                  <Route path="/order" element={<PrivateRoute><Order /></PrivateRoute>}></Route>

                  <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>}>Account</Route>
                  <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>}></Route>
                  <Route path="/account-transaction" element={<PrivateRoute><TransactionHistory /></PrivateRoute>}></Route>
                  <Route path="/account-deposit" element={<PrivateRoute><AccountDeposit /></PrivateRoute>}></Route>
                  <Route path="/account-withdraw" element={<PrivateRoute><AccountWithdraw /></PrivateRoute>}></Route>
                  <Route path="/account-change-password" element={<PrivateRoute><AccountChangePassword /></PrivateRoute>}></Route>
                  <Route path="/account-rejection-logs" element={<PrivateRoute><RejectionLogs /></PrivateRoute>}></Route>
                  <Route path="/account-ledger-master" element={<PrivateRoute><LedgerMaster /></PrivateRoute>}></Route>
                  <Route path="/bill-history" element={<PrivateRoute><BillHistory /></PrivateRoute>} ></Route>
                  <Route path="/plans" element={<PrivateRoute><Plans /></PrivateRoute>} ></Route>
                </Routes>
                <BalanceNotification />
              </NotificationProvider>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;